import React from 'react';
import { HelpTooltip } from '../HelpTooltip';
import {
    StyledFormLabelContainer,
    StyledLabel,
    StyledPlaceholder,
    StyledRequiredMark,
} from './styles';

type FormLabelProps = {
    label?: string | React.ReactNode;
    required?: boolean;
    help?: React.ReactNode;
};
const isEmptyReactNode = (node: React.ReactNode) => {
    if (node == null) return true;
    if (typeof node === 'string') return node.trim() === '';
    if (Array.isArray(node))
        return node.every((child) => isEmptyReactNode(child));
    if (React.isValidElement(node))
        return isEmptyReactNode(node.props.children);
    return false;
};

export function FormLabel(props: Readonly<FormLabelProps>) {
    const { label, required, help } = props;

    if (!label || isEmptyReactNode(label)) return null;

    return (
        <StyledFormLabelContainer>
            {label ? (
                <StyledLabel>
                    {label}{' '}
                    {required ? (
                        <StyledRequiredMark>*</StyledRequiredMark>
                    ) : null}
                </StyledLabel>
            ) : (
                <StyledPlaceholder />
            )}
            {help ? <HelpTooltip help={help} /> : <StyledPlaceholder />}
        </StyledFormLabelContainer>
    );
}
